import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface ClientComputerInfoState {
    list?: any,
  }
  
const initialState:ClientComputerInfoState = {
    list:[],
}

export const ClientComputerInfoSlice = createSlice({
    name:"computerList",
    initialState,
    reducers:{
        UpdateClientComputerInfo: (state,action) => {
            state.list = action.payload.computerList;
        },
        AddClientComputerInfo: (state,action) => {
            state.list = [];
        },
        EditClientComputerInfo: (state,action) => {
            state.list = [];
        },
        RemoveClientComputerInfo: (state,action) => {
            state.list = [];
        }
    }
})

export const {UpdateClientComputerInfo,AddClientComputerInfo,EditClientComputerInfo,RemoveClientComputerInfo} = ClientComputerInfoSlice.actions

export const selectLabList = (state: RootState) => state.computerList

export default ClientComputerInfoSlice.reducer;